import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class HeaderStateService {
  readonly title = signal<string | null>(null);
  readonly subtitle = signal<string | null>(null);

  reset(): void {
    this.title.set(null);
    this.subtitle.set(null);
  }
}
